
import { AssetEntityDecorator } from '../../asset/model/asset.decorator';
import { Asset } from '../../asset/model/asset.model';
import { FIREARM_METADATA } from './firearm.metadata';
import { Firearm } from './firearm.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class FirearmEntityDecoratorBase extends GenericEntityDecorator<Firearm, number> {
  constructor() {
    super(FIREARM_METADATA, {
      get asset(): EntityDecorator<Asset, number> {
        return new AssetEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.assetId == null) {
      return null;
    }
    return parseInt(params.assetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: Firearm): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




